import {Entity} from '../../model/entity.model';
import {Organization} from '../../model/organization.model';


export class SortEntitiesUtil {
  static sortHierarchically(entities: Entity[] | Organization[]): Entity[] | Organization[] {
    const result = [];
    const newEntities = Object.assign(
      [],
      entities.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))
    );

    const array: number[] = newEntities.map((o: Entity | Organization) => o.level);
    const maxLevel = Math.max(...array);

    let lvl: number;

    for (lvl = 1; lvl <= maxLevel; lvl++) {
      let entitiesByLevel = [];
      let parentIdIndex: number = null;

      entitiesByLevel = newEntities.filter(e => e.level === lvl);
      entitiesByLevel.reverse();

      entitiesByLevel.forEach(e => {
        if (e.parentId) {
          parentIdIndex = result.findIndex(parentEntity => parentEntity.id === e.parentId);
          parentIdIndex !== -1 ? result.splice(parentIdIndex + 1, 0, e) : result.push(e);
        } else {
          result.push(e);
        }
      });
    }
    return result;
  }
}
